import Vue from "vue";

export const blogService = {
  listPosts,
  getPost,
  searchPosts
};

function listPosts(params) {
  return Vue.axios.get("/v1/public/posts", { params });
}

function searchPosts(params) {
  return Vue.axios.get(`/v1/public/posts"?search=${params}`);
}

function getPost(slug) {
  return Vue.axios.get(`/v1/public/posts/${slug}`);
}
